import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import Fonts from 'app/utils/Fonts';

const useStyles = makeStyles(theme => ({
    textField: {
        '& .MuiSelect-root': {
            paddingTop: 8,
            paddingBottom: 7
        }
    },
}));

const key = 'FONTFAMILY_';

export default function TextAlign(props) {

    const classes = useStyles();

    const { editorState, onToggle, editorFocus } = props;
    const styleNames = editorState.getCurrentInlineStyle();

    const [ fontFamily, setFontFamily ] = useState('FONTFAMILY_Helvetica');

    useEffect(() => {
        const newFontFamily = styleNames.find(style => style.startsWith(key));

        setFontFamily(newFontFamily || 'FONTFAMILY_Helvetica');
    }, [styleNames]);

    const handleSelect = event => {
        event.preventDefault();
        onToggle(event.target.value, key);
    }

    return (
        <TextField
            id="select-font-family"
            select
            value={fontFamily}
            onChange={handleSelect}
            variant="outlined"
            size="small"
            className={classes.textField}
            >
            {Object.keys(Fonts).map(font => (
                <MenuItem key={font} value={font} style={{fontFamily: Fonts[font].fontFamily}}>
                    {Fonts[font].label}
                </MenuItem>
            ))}
        </TextField>
    );
}
